import { Injectable } from '@angular/core';
import { localStorageConstants, SpinnerService } from 'src/app/shared/services';
import { saveAs } from 'file-saver';
import { GET_ENERGY_CREDITS_EXPORT } from '../queries/energy-credit.queries';
import { Apollo } from 'apollo-angular';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { FacilityAssignment } from '../../users/models/facility-assignment';

@Injectable({
  providedIn: 'root',
})
export class SubmissionsDownloadService {
  constructor(
    private apolloClient: Apollo,
    private spinnerService: SpinnerService,
    private dialog: DialogService,
  ) {}

  downloadSubmissions(filter: object | null): void {
    const userFacAssignments: FacilityAssignment[] = JSON.parse(
      localStorage.getItem(localStorageConstants.USER_FACILITIES_KEY),
    );
    const userFacilities = userFacAssignments.map(
      (i) => i.Facility.KeyChain.LegacyId,
    );
    this.spinnerService.show();
    this.apolloClient
      .query({
        query: GET_ENERGY_CREDITS_EXPORT,
        fetchPolicy: 'no-cache',
        variables: {
          filter: filter ? JSON.stringify(filter) : null,
          userFacilities,
        },
      })
      .subscribe({
        next: (result: any) => {
          try {
            const base64: string = result.data.GetEnergyCreditSubmissionsExport;
            if (!base64) {
              this.dialog.openDialog(
                'No submissions found',
                'No submissions have been returned for download.',
                'Cancel',
                'OK',
                false,
              );
              return;
            }
            const byteString = atob(base64);
            const byteArray = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
              byteArray[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/octet-stream',
            });
            const now = new Date();
            const timestamp = now
              .toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })
              .replace(/\//g, '-');
            saveAs(blob, `CreditSubmissions ${timestamp}.xlsx`);
          } catch {
            this.dialog.openDialog(
              'Failed to download submissions',
              'An error occurred while downloading the submissions. Please try again.',
              'Cancel',
              'OK',
              false,
            );
          } finally {
            this.spinnerService.hide();
          }
        },
        error: () => {
          this.spinnerService.hide();
          this.dialog.openDialog(
            'Failed to download submissions',
            'An error occurred while downloading the submissions. Please try again.',
            'Cancel',
            'OK',
            false,
          );
        },
      });
  }
}
